import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../../Context/ThemeContext";

const ButtonPrimary = ({
  text,
  icon,
  onClick,
  iconR,
  variant = "primary",
  disabled,
  type = "button",
}: {
  text: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  iconR?: React.ReactNode;
  variant?: "primary" | "secondary" | "success";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const baseClasses =
    "w-full cursor-pointer px-7 py-[10px] justify-center flex items-center gap-2 flex-shrink-0 self-stretch text-[14px]  shadow-[0_3px_13.6px_0_rgba(0,0,0,0.03)] font-medium transition-all disabled:cursor-not-allowed disabled:opacity-60 disabled:pointer-events-none";

  const variants = {
    primary: `
      bg-[${theme.colorPrimary}]
      border border-[#E2E2E2]
      text-white
      hover:bg-[${theme.colorPrimary}]
    `,
    secondary: `
      bg-white
      border 
      border-[#E2E2E2]
      text-grayText
      hover:bg-[${theme.colorPrimary}]
    `,
    success: `
      bg-[#248358]
      border 
      border-[#E2E2E2]
      text-white
      hover:bg-[${theme.colorPrimary}]
    `,
  };

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]}`}
    >
      {icon && <span>{icon}</span>}
      {t(text)}
      {iconR && <span>{iconR}</span>}
    </button>
  );
};

export default ButtonPrimary;
